import React, { useEffect, useState } from "react";
import axios from "axios";
import OrderTable from "../../Utills/Table/OrderTable";
import Order from "../../components/Modal/Order/OrderModal";
import Switch from "@mui/material/Switch";
import OrderDetialModal from "../../components/Modal/Order/OrderDetialModal";
import OrderInfoDetailModal from "../../components/Modal/Order/OrderInfoDetail";

const ProductPage = ({ check, change }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [orders, setOrders] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [openDetail, setOpenDetail] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState([]);

  const handleClose = () => {
    setOpen(false);
    setOpenDetail(false);
  };

  const onDeliveryStatusChange = async (order) => {
    try {
      await axios.put(
        `https://tsetsegtuw.templateapi.xyz/order/id/${order._id}`,
        {
          isDelived: !order.isDelived,
        }
      );
      // Захиалгын жагсаалтыг шинэчлэх
      setLoading(true);
    } catch (error) {
      console.error("Захиалгын төлөв өөрчлөхөд алдаа гарлаа:", error);
    }
  };

  useEffect(() => {
    if (loading) {
      // axios.get('https://tsetsegtuw.templateapi.xyz/order')
      axios
        .get("https://tsetsegtuw.templateapi.xyz/order?sort=-createdAt")
        .then((e) => setOrders(e.data.data))
        .catch((e) => console.log(e))
        .finally(() => setLoading(false));
    }
  }, [loading]);

  if (loading) {
    return <div className="order"></div>;
  }

  return (
    <div className="flex flex-col items-center justify-start min-h-screen ml-[18vw] w-[80vw] p-6">
      <div className="w-full flex justify-end mb-4">
        {open ? (
          <OrderDetialModal
            open={open}
            handleClose={handleClose}
            selectedData={selectedData}
          />
        ) : null}
        {openDetail ? (
          <OrderInfoDetailModal
            open={openDetail}
            handleClose={handleClose}
            data={selectedProduct}
          />
        ) : null}
        <Switch
          checked={check}
          onChange={change}
          inputProps={{ "aria-label": "controlled" }}
        />
        <Order />
      </div>
      <div className="w-full max-w-7xl">
        <OrderTable
          orders={orders}
          setOpen={setOpen}
          setSelectedData={setSelectedData}
          setSelectedProduct={setSelectedProduct}
          setOpenDetail={setOpenDetail}
          onDeliveryStatusChange={onDeliveryStatusChange}
        />
      </div>
    </div>
  );
};

export default ProductPage;
